<template>
  <div class="scroll-to-top" ref="wrapper">
    <i class="icon wb-arrow-up"></i>
  </div>
</template>

<script>
export default {
  name: 'scroll-to-top',
  mounted () {
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 200) {
        $('.scroll-to-top').css('visibility', 'visible')
      }
      else {
        $('.scroll-to-top').css('visibility', 'hidden')
      }
    })

    //scrollovaci tlacitko, event na click
    $('.scroll-to-top').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 200)
      return false
    })
  },

  destroyed () {
    $(window).off('scroll')
  }
}
</script>

<style scoped>
.scroll-to-top {
  width: 52px;
  height: 52px;
  background: #428bca;
  position: fixed;
  right: 10px;
  bottom: 10px;
  display: flex;
  border-radius: 50px;
  align-items: center;
  justify-content: center;
  visibility: hidden;
}

.scroll-to-top i {
  color: #FFFFFF;
  font-size: 35px;
}
</style>
